var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import '@ungap/custom-elements';
import * as fgui from "fairygui-dom";
var _bagWindow;
function start() {
    return __awaiter(this, void 0, void 0, function* () {
        yield fgui.UIPackage.loadPackage("assets/Bag");
        let view = fgui.UIPackage.createObject("Bag", "Main").asCom;
        view.makeFullScreen();
        fgui.GRoot.inst.addChild(view);
        _bagWindow = new BagWindow();
        view.getChild("bagBtn").onClick(() => {
            _bagWindow.show();
        });
    });
}
class BagWindow extends fgui.GWindow {
    constructor() {
        super();
    }
    onInit() {
        this.contentPane = fgui.UIPackage.createObject("Bag", "BagWin").asCom;
        this.center();
    }
    onShown() {
        var list = this.contentPane.getChild("list");
        list.on("click_item", this.onClickItem, this);
        list.itemRenderer = this.renderListItem.bind(this);
        list.setVirtual();
        list.numItems = 45;
    }
    renderListItem(index, obj) {
        obj.icon = "assets/Icons/i" + Math.floor(Math.random() * 10) + ".png";
        obj.text = "" + Math.floor(Math.random() * 100);
    }
    onClickItem(evt) {
        let item = evt.data;
        this.contentPane.getChild("n11").icon = item.icon;
        this.contentPane.getChild("n13").text = item.icon;
    }
}
start();
